export default __webpack_public_path__ + "static/media/travel_stamps.2c10caef.png";